export default "__VITE_ASSET__COxIuCVb__"